var xxl = '(min-width: 135em)';
var xl = '(min-width: 105em)';
var lg = '(min-width: 90em)';
var md = '(min-width: 75em)';
var sm = '(min-width: 45em)';
var xs = '(max-width: 45em)';
var breakpoints = {
  xxl: "@media screen and " + xxl,
  xl: "@media screen and " + xl,
  lg: "@media screen and " + lg,
  md: "@media screen and " + md,
  sm: "@media screen and " + sm,
  xs: "@media screen and " + xs
};
var containerBreakpoints = {
  xxl: "@container " + xxl,
  xl: "@container " + xl,
  lg: "@container " + lg,
  md: "@container " + md,
  sm: "@container " + sm,
  xs: "@container " + xs
};

export { breakpoints, containerBreakpoints };
